module.exports = __webpack_public_path__ + "img/01.85d47a84.png";